// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"295":"88cd7703","453":"1843f74c"}[chunkId] + ".chunk.js";
};